import React from "react";
import { useTranslation } from "react-i18next";
import { BriefDetails } from "src/model/model";

interface SpeechToCheckDetailsProps {
  data: BriefDetails | Record<string, unknown>;
  mode: "plan" | "recap";
}

const ns = "pages.chat.interactionDetails";

const SpeechToCheckDetails: React.FC<SpeechToCheckDetailsProps> = ({ data, mode }) => {
  const { t } = useTranslation();
  if (!data) return null;

  if (mode === "plan") {
    const bd = data as BriefDetails;
    if (!bd.expectedKeywords?.length) return null;
    return (
      <div className="text-[11px] text-gray-700">
        <span className="font-medium text-gray-500">{t(`${ns}.keywords`)} : </span>
        <span className="flex flex-wrap gap-1 mt-0.5">
          {bd.expectedKeywords.map((kw, i) => (
            <span
              key={i}
              className="px-1.5 py-0.5 rounded bg-teal-50 text-teal-700 border border-teal-200"
            >
              {kw}
            </span>
          ))}
        </span>
      </div>
    );
  }

  // Recap mode
  const d = data as Record<string, unknown>;
  const keywords = d.keywords_info as Array<{ word?: string }> | undefined;
  if (!keywords?.length) return null;
  return (
    <div className="space-y-1 text-[11px] text-gray-700">
      {d.title && (
        <div>
          <span className="font-medium text-gray-500">{t(`${ns}.label`)} : </span>
          {String(d.title)}
        </div>
      )}
      <div>
        <span className="font-medium text-gray-500">{t(`${ns}.keywords`)} : </span>
        {keywords.map((k) => k.word || "").join(", ")}
      </div>
    </div>
  );
};

export default SpeechToCheckDetails;
